export const SnapchatHubCommands = {
    registerByRequestId: 'registerByRequestId',
    unRegisterByRequstId: 'unRegisterByRequestId',
}

export const SnapchatHubEvents = {
    handpickChangesReady: 'HandpickChangesReady',
    handpickChangeNotification: 'HandpickChangeNotification'
}
